require('@fortawesome/fontawesome-free/js/all');
